import { render, staticRenderFns } from "./Detail8.vue?vue&type=template&id=30c6a2e0&scoped=true&"
import script from "./Detail8.vue?vue&type=script&lang=js&"
export * from "./Detail8.vue?vue&type=script&lang=js&"
import style0 from "./Detail8.vue?vue&type=style&index=0&id=30c6a2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c6a2e0",
  null
  
)

export default component.exports